import angular from 'angular';

type Status = {
    code: string;
    reason: string | null;
};

type Cabin = {
    type: string;
    rbd: string;
    numToUse: number;
};

type Segment = {
    cabins: Cabin[];
    id: string;
    status: Status;
};

type WaitingList = {
    coupons: { numToUse: number }[];
    segments: Segment[];
};

type Ancillary = {
    status: { code: string };
    type: string;
    waitingList: WaitingList;
};

export type TransformerWaitingList = {
    ancillariesAvailable?: string[];
    bidsUpgradingInfo?: {
        waitingListAvailable?: boolean,
        freeUpgradesAvailable ?: number,
        bidsSegmentsWL?: any, // segments
        ancillariesTripsWL?: any
    }
};

export type BidsUpgradingInfo = {
    ancillariesTrips?: any[],
    ancillariesTripsFinished?: any[],
    ancillariesTripsWL?: any [],
    aviosBidAvailable: boolean,
    bidsAvailable: boolean,
    bidsBlocked: boolean,
    bidsClosed: boolean,
    bidsSegments?: any [],
    bidsSegmentsWL?: any, // segments
    currency: string,
    freePossibility: boolean,
    freeUpgradesAvailable: boolean,
    priceFrom: number,
    totalAmountBidsFormated: string,
    waitingListAvailable: boolean
};

export class WaitingListAncillary {

    buildWaitingListData = (ancillary: Ancillary): TransformerWaitingList => {
        const bidsSegmentsWL = ancillary.waitingList.segments.filter(item => item.cabins.length > 0);

        const isAvailableAncillary = ancillary.status.code === 'AVAILABLE';
        if (isAvailableAncillary) {
            return {
                ancillariesAvailable: [ancillary.type],
                bidsUpgradingInfo: {
                    bidsSegmentsWL,
                    waitingListAvailable: true,
                    freeUpgradesAvailable: this.getTotalFreeUpgradesAvailable(ancillary)
                }
            };
        }
        return null;
    };


    getTotalFreeUpgradesAvailable = (ancillary: { waitingList: { coupons: { numToUse: number }[] } }): number =>
        ancillary.waitingList.coupons.reduce((total, coupon) => total + coupon.numToUse, 0);
}


WaitingListAncillary.$inject = [];
try {
    const mod = angular.module('ib-web-ancillaries-module');
    mod.service('WaitingListAncillary', WaitingListAncillary);
} catch (error) {
    const mod = angular.module('ib-web-ancillaries-module', []);
    mod.service('WaitingListAncillary', WaitingListAncillary);
}